import { render, staticRenderFns } from "./companyInvitationApprovalDetail.vue?vue&type=template&id=05f40c3c&scoped=true&"
import script from "./companyInvitationApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./companyInvitationApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./companyInvitationApprovalDetail.vue?vue&type=style&index=0&id=05f40c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f40c3c",
  null
  
)

export default component.exports